<template>
	<el-dialog
		title="采购订单预览"
		:visible.sync="visible"
		center
		width="80%"
		@close="handlerCancel"
		:close-on-click-modal="false"
	>
		<el-table ref="table" width="100%" class="rc_table" highlight-current-row @selection-change="selection"  row-key="id" :data="list" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" :row-class-name="tableRowClassName">
			<el-table-column align="center" type="selection" width="50"></el-table-column>
			<el-table-column align="center"  property="supplier_user.nickname" label="供应商" show-overflow-tooltip width=""></el-table-column>
			<el-table-column align="center"  property="dd_order_id" label="抖店订单ID" show-overflow-tooltip width=""></el-table-column>
			<el-table-column align="center"  property="product_spec" label="商品规格" show-overflow-tooltip width=""></el-table-column>
			<el-table-column align="center"  property="order_amount" label="订单金额" show-overflow-tooltip width=""></el-table-column>
			<el-table-column align="center"  property="total_cost_price" label="采购金额" show-overflow-tooltip width="">
				<template slot-scope="scope">
					{{scope.row.is_exchange==1?'换货':scope.row.total_cost_price}}
				</template>
			</el-table-column>
			<el-table-column align="center"  property="freight_price" label="预估代发费" show-overflow-tooltip width=""></el-table-column>
			<el-table-column align="center"  property="total_price" label="合计" show-overflow-tooltip width=""></el-table-column>
		</el-table>

		<div class="preview">
			<div class="item" v-for="(item,index) in checkout_data" :key="index">
				<div class="pay-code">
					<div class="title">支付宝扫码支付</div>
					<div v-if="item.pay_state==0">
            <div>
              <img class="code" v-if="item.qr_code_url" :src="item.qr_code_url" alt="">
              <div class="code" v-if="!item.qr_code_url">刷新</div>
            </div>
					</div>
					<div v-if="item.pay_state==1">
						<div class="code flex-wrap">
              <div><i class="iconfont el-icon-check" style="color: green;font-size: 24px;"></i></div>
              <div>支付成功</div>
            </div>
					</div>
				</div>
				<div style="margin-top: 5px;">供应商：{{item.nickname}}</div>
				<div>订单数：<span style="font-weight: bold;">{{item.order_num}} </span>笔订单</div>
				<div style="color: #f0413e;">毛利：￥{{item.order_profit}}</div>
				<div style="color: #f0413e;font-weight: bold;">合计：￥{{item.total_price}}</div>
				<!-- <el-button class="pay-btn" size="mini" type="primary" >采购支付</el-button> -->
			</div>

		</div>
		<span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">关 闭</el-button>
    </span>
	</el-dialog>
</template>

<script>
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
export default {
	name: "orderServerPurchase",
	data() {
		return {
			visible: false,
			list: [],
			ids:[],
			checkout_data: [],
			check_pay_state_itv: 0
		}
	},
	mounted() {

	},
	methods: {
		...mapActions({
			opOrderServerPurchase: "ucenter/opOrderServerPurchase",
			opOrderServerPurchaseCheckout: "ucenter/opOrderServerPurchaseCheckout",
			getOrderServerPurchaseState: "ucenter/getOrderServerPurchaseState",
		}),

		tableRowClassName({row, rowIndex}) {
			if (parseFloat(row.total_price) > parseFloat(row.order_amount)) {
				return 'warning-row';
			}
			return '';
		},
		open(list){
			let that = this
			this.list = list
			let order_product_ids = []
			for(var i in list){
				order_product_ids.push(list[i].id)
			}
			this.ids = order_product_ids
			this.visible = true

			setTimeout(function(){
				const rows = that.$refs.table.data
				rows.forEach(row => {
					that.$refs.table.toggleAllSelection(row);
				})
			},100)

		},
		checkout(){
			let that = this
			let param = {ids:this.ids.join(',')}
			this.opOrderServerPurchaseCheckout({
				data: param, success: (res) => {
					if (res.code === 200) {
						let checkout_data = res.data
						that.checkout_data = checkout_data
						let all_pay = that.is_all_pay()
						if(!all_pay){
							that.check_pay_state_itv = setInterval(function(){
								that.refreshPurchaseState()
							},2000)
						}

					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		is_all_pay(){
			let all_pay = true
			let checkout_data = this.checkout_data
			for(var i in checkout_data){
				if(checkout_data[i].pay_status != 1){
					all_pay = false
				}
			}
			return all_pay
		},
		selection(selection) {
			this.ids = selection.map(item => item.id)
			this.checkout()
		},
		refreshPurchaseState() {
			let that = this
			let checkout_data = this.checkout_data
			let order_no = []
			for(var i in checkout_data){
					order_no.push(checkout_data[i].order_no)
			}
			let param = {order_no:order_no}
			this.getOrderServerPurchaseState({
				data: param, success: (res) => {
					if (res.code === 200) {
						let states = res.data
						for(var i in checkout_data){
							let index = states.findIndex(val => val.order_no == checkout_data[i].order_no)
							that.checkout_data[i].pay_state = states[index].pay_status
						}
						let all_pay = that.is_all_pay()

						if(all_pay && that.check_pay_state_itv){
							clearInterval(that.check_pay_state_itv)
							that.check_pay_state_itv = 0
						}
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		handlerCancel() {
			if(this.check_pay_state_itv){
				clearInterval(this.check_pay_state_itv)
				this.check_pay_state_itv = 0
			}
			this.visible = false;
			this.$emit('complete')
		}
	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 28px 0 40px;display: flex;justify-content: space-between;flex: 1;min-height: 500px;}
.rc_main{padding: 36px 40px 46px;}
.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 15px;}
.select_wrap .w290{width: 290px;margin-top: 14px;margin-right: 15px;position: relative;}
.select_wrap .w290:nth-child(3n){margin-right: 0;}
.el-cascader{line-height: 34px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.tree_checkall{margin-top: 12px;}
.tree_box{padding: 10px;width: 100%;border: 1px solid #DCDFE6;border-radius: 4px;box-sizing: border-box;max-height: 250px;overflow: hidden auto;margin-top: 12px;}
.tree_box::-webkit-scrollbar{width:4px;}
.tree_box::-webkit-scrollbar-thumb{background: #DDDDDD;border-radius: 4px;}
.tree_box::-webkit-scrollbar-track{background: #F2F2F2;border-radius: 4px;}
.w100{width: 100%;}
.preview{padding: 10px 0;line-height: 1.8;}
.preview .item{padding:10px;border: 1px solid #eee;display: inline-flex;flex-direction: column;margin-right: 10px;}
.preview .item .pay-code{display: flex;flex-direction: column;align-items: center;justify-content: center;width: 154px;height: 174px;}
.preview .item .pay-code .title{color: #666;}
.preview .item .pay-code .code{width: 150px;height: 150px;object-fit: contain;display: flex;align-items: center;justify-content: center;background-color: #eee;cursor: pointer;}
.preview .pay-btn{margin-top: 10px ;}
</style>
<style>
.el-cascader{width: 100%;}
.select_wrap .el-button{margin-top: 14px;}
.select_wrap .el-input--prefix .el-input__inner,.select_wrap .el-cascader .el-input .el-input__inner{padding-left: 76px !important;height: 34px;line-height: 34px;font-size: 12px !important;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.select_wrap .el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}
.totals_btn .el-button--primary.is-plain{border-color: #fff;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-input.is-focus .el-input__inner,.el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}
.rc_table.el-table th.el-table__cell>.cell{padding: 0 14px;}
table{width: 100% !important;}

.el-table .warning-row {
	background: #feecec;
}

.el-table .success-row {
	background: #f0f9eb;
}
.el-table__body tr.current-row>td.el-table__cell{
	background-color: unset;
}
</style>
